module.exports = __webpack_public_path__ + "img/classify-item4.4042353b.png";